import { RequiredError, isProp } from "shelving";
import { Page, PathButton } from "shared/react";
import { type CreatorEntity, EARNED_MAX, REWARD_TYPES } from "shared/schema";
import { EntityHeader } from "../entity/EntityHeader.js";
import { EarnedRewardGrid } from "../reward/RewardGrid.js";
import { useProfileAllowedPrivacyTypes } from "../util/privacy.js";
import { useProfileContext } from "./ProfileContext.js";

export function EarnedPage({ type = "badge" }: { type?: string }): React.ReactElement {
	const { id: uid } = useProfileContext();
	const allowed = useProfileAllowedPrivacyTypes(uid);
	const creator: CreatorEntity = `profile:${uid}`;
	if (isProp(REWARD_TYPES, type)) {
		return (
			<Page title={`Earned ${type}s`} path={`./earned/${type}s`}>
				<EntityHeader entity={creator}>
					<h1>{`Earned ${type}s`}</h1>
				</EntityHeader>
				<nav className="size-small space-none width-full fill-panel">
					<div className="flex-row flex-stretch width-wide">
						{Object.entries(REWARD_TYPES).map(([key, title]) => (
							<PathButton key={key} path={`../${key}s`}>
								{`${title}s`}
							</PathButton>
						))}
					</div>
				</nav>
				<EarnedRewardGrid
					type={type}
					query={{
						uid,
						type,
						privacy: allowed,
						$order: "!created",
						$limit: EARNED_MAX,
					}}
				/>
			</Page>
		);
	}
	throw new RequiredError("Unknown reward type", type);
}
